import React from "react";
import { Box, Typography, Button } from "@mui/material";
// import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
interface HeaderUserGoProps {
  name?: string | null | undefined;
  text?: string;
  icon?: React.ReactNode;
  buttonText?: string;
  onClick?: () => void;
  iconButton?: React.ReactNode;
}

const HeaderUserGo = ({
  name,
  text,
  icon,
  buttonText,
  onClick,
  iconButton,
}: HeaderUserGoProps) => {
  return (
    <Box
      sx={{
        height: "166px",
        backgroundColor: "#097185",
        padding: {
          xs: "20px 16px",
          sm: "30px 40px",
        },
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box
        sx={{ display: "flex", flexDirection: "column", gap: 1, color: "#fff" }}
      >
        <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <Typography sx={{ fontSize: { xs: "20px", sm: "30px" } }}>
            {name}
          </Typography>
          <Box
            sx={{
              width: { xs: 27, sm: 34 },
              height: { xs: 27, sm: 34 },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",

              "& svg, & img": {
                width: "100%",
                height: "100%",
              },
            }}
          >
            {icon}
          </Box>
        </Box>
        <Typography sx={{ fontSize: { xs: "13px", sm: "20px" } }}>
          {text}
        </Typography>
      </Box>
      {buttonText && (
        <Box>
          <Button
            variant="outlined"
            onClick={onClick}
            sx={{
              width: { xs: "100px", sm: "145px" },
              display: "flex",
              flexDirection: "row",
              cursor: "pointer",
              fontWeight: 600,
              color: "#2CA6A4",
              backgroundColor: "#FFFFFF",
              borderRadius: "13px",
              border: "none",
              fontSize: { xs: "12px", sm: "14px", md: "16px" },
              "&:hover": {
                backgroundColor: "#84f0ee8c",
                color: "#fff",
              },
            }}
          >
            {iconButton || <KeyboardBackspaceOutlinedIcon />}
            {buttonText}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default HeaderUserGo;
